$(document).on('turbolinks:load', function () {




    $('.pdf-thera-btn').on('click', function () {
        console.log($(this).attr('pdf'));
        $(".pdf-pop .header-text").html($(this).attr('title'));

        $(".pdf-pop").show();

        $(".pdf-pop .popup-content").html('<iframe src="/pdfviewer?file='+ encodeURIComponent($(this).attr('pdf')) +'#page=' +  $(this).attr('page') + '" width="100%" height="600px" />')
    })

    $(".modal-close").on('click', function () {
        $(".pdf-pop").hide();

    })
    $('body').on('click', '.pdf-link', function () {
        console.log($(this).attr('pdf'));

        $(".pdf-pop").show();

        $(".pdf-pop .popup-content").html('<iframe src="/pdfviewer?file='+ encodeURIComponent($(this).attr('pdf')) +'#page=' +  $(this).attr('page') + '" width="100%" height="600px" />')
    })
})
